import { render, staticRenderFns } from "./FormFile.vue?vue&type=template&id=4a26da1e&scoped=true&lang=pug"
import script from "./FormFile.vue?vue&type=script&lang=ts"
export * from "./FormFile.vue?vue&type=script&lang=ts"
import style0 from "./FormFile.vue?vue&type=style&index=0&id=4a26da1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a26da1e",
  null
  
)

export default component.exports